module.exports = "/static/assets/7695b6f141042be8657724e077c1412b.png";